import { render, staticRenderFns } from "./MyClientsListContainer.vue?vue&type=template&id=7881a7a1&"
import script from "./MyClientsListContainer.vue?vue&type=script&lang=js&"
export * from "./MyClientsListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports